var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.824 17.92v-5.405h4.348v5.404c0 .595.489 1.081 1.086 1.081h3.261c.598 0 1.087-.486 1.087-1.08v-7.566h1.848c.5 0 .74-.616.359-.94l-9.087-8.138a1.1 1.1 0 0 0-1.457 0L.182 9.414a.538.538 0 0 0 .36.94h1.847v7.565c0 .595.49 1.081 1.087 1.081h3.26c.599 0 1.088-.486 1.088-1.08"
})));
export default SvgHome;